import React from 'react'
import { ImageGridLayout, RichTextRenderer } from '../../../lib/components'
import { CMSOpportunityDetailsExecutiveSummaryType } from '../../../lib/types'
import { CmsSectionText } from './cms-section-text-content'

const CMSExecutiveSummary = ({
  executiveSummary,
}: {
  executiveSummary?: CMSOpportunityDetailsExecutiveSummaryType
}) => {
  return (
    <>
      {executiveSummary?.executiveSummaryText?.length ? (
        <CmsSectionText dataTestId='cms-executive-summary-text'>
          <RichTextRenderer
            content={executiveSummary.executiveSummaryText}
            variant='opportunity-details'
          />
        </CmsSectionText>
      ) : null}
      {executiveSummary?.executiveSummaryImages &&
        executiveSummary.executiveSummaryImages.length > 0 && (
          <ImageGridLayout
            images={executiveSummary.executiveSummaryImages}
            layoutColumns={executiveSummary?.layoutColumns}
            dataTestId='cms-executive-summary-image-layout'
            splitMiddleColumn={true}
            layoutContainerClasses='opportunity-cms-section-image-layout'
          />
        )}
    </>
  )
}

export { CMSExecutiveSummary }
